<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
    <div class="bottom">
      <span>
        <img src="../../../static/images/ga.png" alt />
      </span>
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010202001899"
        target="_blank"
        style="margin-right:10px;"
        @click="run()"
      >浙公网安备33010202001899号</a>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备2021021896号-1</a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key () {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /*50 = navbar  */
  min-height: calc(100vh - 50px);
  min-width: 1024px;
  width: 100%;
  position: relative;
  // overflow: hidden;
  padding: 20px 20px 20px 20px;
  > div {
    min-height: 83vh;
  }
}
.fixed-header + .app-main {
  padding-top: 50px;
}
.bottom {
  position: static;
  left: 0;
  right: 0;
  bottom: 0;
  color: #fff;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px !important;
  width: 100%;
  img {
    width: 16px;
    margin-top: 3px;
    margin-right: 5px;
  }
  a {
    color: #969696;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue